<script>
	import {docs} from "../store.js";
	import Controlador from "../controlador.svelte";
	import {onMount,beforeUpdate} from "svelte";
	let c;
	let tatuadores = [];
	let perforadores = [];
	let actual = [];
	let etapa = 0;
	onMount(()=>{
		c.actualizarDocs();
		tatuadores = $docs.filter((el)=>el._id.includes("empleado:") && el.cargo == "Tatuador");
		perforadores = $docs.filter((el)=>el._id.includes("empleado:") && el.cargo == "Perforador");			
	})
	beforeUpdate(()=>{
		if (tatuadores){
		tatuadores = $docs.filter((el)=>el._id.includes("empleado:") && el.cargo == "Tatuador");
		perforadores = $docs.filter((el)=>el._id.includes("empleado:") && el.cargo == "Perforador");
		}
	})
	function tattoo(){
		etapa = 1;
		actual = tatuadores;
	}
	function perfo(){
		etapa = 1;
		actual = perforadores;
	}
	function volver(){
		etapa = 0;
		actual = [];
	}
</script>
<Controlador bind:this={c} />
<div class="w-full h-full flex flex-col items-center justify-center">
	<div class="m-4 flex items-center overflow-hidden shadow justify-center rounded-full w-1/3">
		<img src="logo.jpeg" alt="logo" />
	</div>
	{#if etapa == 0}
		<div class="w-full p-2 flex flex-col items-center justify-start">
			<button on:click={tattoo} class="w-full m-2 p-2 rounded shadow bg-red-500 text-white flex items-center justify-center">
				Tatuador/a
			</button>
			<button on:click={perfo} class="w-full m-2 p-2 rounded shadow bg-red-500 text-white flex items-center justify-center">
				Perforador/a
			</button>
		</div>
	{:else}
		<div class="w-full p-2 flex flex-col items-center justify-start">
			<button on:click={volver} class="w-full m-2 p-2 rounded shadow bg-red-500 text-white flex items-center justify-center">
				Volver
			</button>
			{#each actual as item}
				<a href={`#/lista/${item._id}`} class="w-full m-2 p-2 rounded shadow bg-red-500 text-white flex items-center justify-center">
					{item.sobrenombre}
				</a>
			{/each}
		</div>
	{/if}
</div>
